module.exports = __webpack_public_path__ + "img/closeIconW.974053e3.svg";